// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { Toastr } from "../../../../revvComponents";

// Components Imports
import ManageTeammatesPopup from "../../../SettingsWrapper/TeammatesSettings/ManageTeammatesPopup";

// Actions Imports
import { UserActions } from "../../../../actions";

// Internal Imports
import { GlobalUtils, AmplitudeUtils } from "../../../../utils";
import { EVENTS } from "../../../../constants";

// Destructuring
const { handleApiErrMsg } = GlobalUtils;
const { initTeammatesSettingsData } = UserActions;

class NavBarInviteTeammate extends Component {
  state = {
    showLoader: false,
    isInviteThroughEditPopup: false,
  };

  componentDidMount() {
    AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.TEAMMATES_PAGE_VIEWED);
    // this._initTeammatesData();
  }

  _initTeammatesData = () => {
    this.setState({ showLoader: true });
    this.props
      .initTeammatesSettingsData()
      .then(() => {
        this.setState({ showLoader: false });
      })
      .catch(error => {
        this.setState({ showLoader: false });
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        console.error(
          `NavBarInviteTeammate => _initTeammatesData => Error :${error}`,
        );
      });
  };

  _togglePopup = () => {
    this.props.closePopup("showTeammatePopup", false);
  };

  _updateState = (type, value) => {
    this.setState({ [type]: value });
  };

  render() {
    return (
      <ManageTeammatesPopup
        closePopup={this._togglePopup}
        updateState={this._updateState}
        roles={this.props.orgRolesList}
        teammate={{}}
        isInviteThroughEdit={this.state.isInviteThroughEditPopup}
        externalLoader={this.state.showLoader}
        isInviteFromNavbar
        usage={this.props.userConsumptionRecord}
      />
    );
  }
}

const mapStateToProps = state => {
  const { teammatesList: allteammates, orgRolesList } = state.SettingsStore;
  let teammatesList = [];
  if (allteammates && allteammates.length > 0) {
    teammatesList = allteammates.filter(teammate => !teammate.is_external);
  }
  return { teammatesList, orgRolesList };
};

const mapDispatchToProps = {
  initTeammatesSettingsData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavBarInviteTeammate);
